import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayL, LabelM } from '@sorare/core/src/atoms/typography';

import { Step } from 'components/rewards/BoxOpeningOnboardingDialog/CardOpeningOnboardingDialog/Step';

import { SerialNumber_player } from './__generated__/index.graphql';

type Props = { player: SerialNumber_player; serialNumber: number };
export const SerialNumber = ({ player, serialNumber }: Props) => {
  return (
    <Step
      player={player}
      badge={
        <LabelM color="var(--c-rivals-friendlies)" bold>
          {serialNumber}/1000
        </LabelM>
      }
      color="#00fff7"
      description={
        <Vertical gap={0.5}>
          <FormattedMessage
            id="BoxOpeningOnboardingDialog.serialNumberStep.descriptionWithSerialNumber"
            defaultMessage="<xs>Digital Collectible</xs><xl>Edition {br}{serialNumber}/1000</xl><md>Collect and trade cards with other managers around the world.</md>"
            values={{
              br: <br />,
              xs: content => <LabelM>{content}</LabelM>,
              xl: content => (
                <DisplayL color="var(--c-rivals-friendlies)">
                  {content}
                </DisplayL>
              ),
              md: content => <LabelM>{content}</LabelM>,
              serialNumber,
            }}
          />
        </Vertical>
      }
    />
  );
};

SerialNumber.fragments = {
  player: gql`
    fragment SerialNumber_player on Player {
      slug
      ...Step_player
    }
    ${Step.fragments.player}
  ` as TypedDocumentNode<SerialNumber_player>,
};
